<h1>Albion Free Market FAQ</h1>
<mat-accordion multi="true">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>PRICES</mat-panel-title>
    </mat-expansion-panel-header>
    <h3 style="font-weight: 500">What are the differences between "buy order", "sell order" and "average price"?</h3>
    <p>
      Buy from buy order means you are setting up a buy order in the market. For that, you need to pay a setup fee, which is included in the calculations done
      by Albion Free Market for crafting. When you choose this option, the price loaded from the database is the price of the highest buy order available.
    </p>
    <p>
      Buy from sell order means you are buying from an existing sell order in the market. There's no setup fee. When you choose this option, the price loaded
      from the database is the price of the lowest sell order available.
    </p>
    <p>
      Sell to buy order means you are selling to an existing buy order in the market. There's no setup fee. When you choose this option, the price loaded from
      the database is the price of the highest buy order available.
    </p>
    <p>
      Sell to sell order means you are setting up a sell order in the market. For that, you need to pay a setup fee, which is included in the calculations done
      by Albion Free Market for crafting. When you choose this option, the price loaded from the database is the price of the lowest sell order available.
    </p>
    <p>
      When you choose average price the system loads the average price of the item for the number of days you set. By default, we assume that average means
      you'll setup an order (either buy or sell) and pay the setup fee, which is included in the calculations done by Albion Free Market for crafting.
    </p>
    <h3 style="font-weight: 500">Where does the price data come from?</h3>
    <p>
      The price data is obtained from the <a href="https://www.albion-online-data.com/" target="_blank">Albion Online Data Project</a>. This project collects
      real-time information from Albion Online through a client that monitors the game's network traffic, identifying and sending relevant market data to a
      central server.
    </p>
    <h3 style="font-weight: 500">Why are there sometimes no prices for certain items?</h3>
    <p>
      Prices might be unavailable for some items if they have not been recently accessed in the game by players using the data collection client. The dataset
      depends on active player interactions within the game's market.
    </p>
    <h3 style="font-weight: 500">How can I contribute to uploading price data?</h3>
    <p>
      Contribute by downloading and operating the Albion Data Project client while playing Albion Online. The client will automatically gather and upload market
      order data to the central server.
    </p>
    <h3 style="font-weight: 500">Can I blindly trust the prices shown on the website?</h3>
    <p>
      No, there may be inaccuracies occasionally. Also, the price data lacks quantity information. This means if you need to buy a large quantity of an item,
      the average price paid may be higher than the minimum price shown on the website. For accurate crafting and transporting costs, input the prices you
      actually paid.
    </p>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>CRAFTING</mat-panel-title>
    </mat-expansion-panel-header>
    <h3 style="font-weight: 500">Why are multiple items shown on the crafting screen?</h3>
    <p>This allows you to view all results for a category simultaneously, making it easier to identify the most profitable option.</p>
    <h3 style="font-weight: 500">How do you calculate the amount of items to buy, considering the Resource Return Rate?</h3>
    <p>
      Our advanced algorithm strives for accuracy in determining the correct quantity of items. However, Albion Online incorporates some randomness, so
      occasionally, you might find yourself short on ingredients.
    </p>
    <h3 style="font-weight: 500">Does setting PREMIUM automatically determine the correct Resource Return Rate?</h3>
    <p>No. You must manually select the Resource Return Rate (RRR).</p>
    <h3 style="font-weight: 500">What do BUY FROM and SELL TO mean?</h3>
    <p>
      This indicates the type of transaction. Buying from a BUY ORDER, set by you, can offer better prices but incurs a SETUP FEE. Buying from a SELL ORDER
      means purchasing from another player's market order.
    </p>
    <p>
      Choosing AVERAGE uses the average price for the NUMBER OF DAYS set. By default, we assume that AVERAGE means you'll setup and order (either BUY or SELL)
      and pay the SETUP FEE.
    </p>
    <h3 style="font-weight: 500">What should I do in the SPECS tab?</h3>
    <p>Enter your crafting skill levels here. This affects the FOCUS cost of crafting, relevant only if you choose to use Focus.</p>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>TRANSPORT</mat-panel-title>
    </mat-expansion-panel-header>
    <h3 style="font-weight: 500">Why can't I choose a sell location?</h3>
    <p>All sell locations are displayed by default, eliminating the need for selection.</p>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>ITEM POWER</mat-panel-title>
    </mat-expansion-panel-header>
    <h3 style="font-weight: 500">What's the purpose of this tool?</h3>
    <p>
      This tool helps you select the most cost-effective gear within a specified Item Power (IP) range. It's useful when deciding between options like a 6.0
      masterpiece or a 4.3 normal item.
    </p>
  </mat-expansion-panel>
